import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/app/services/home.service';
import { servicesUrl } from 'src/app/services/servicesUrl';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  slideConfig = { "slidesToShow": 1, autoplay: true, draggable: true, autoplaySpeed: 3000 };

  arraySlider: any
  load: boolean = false
  imgUrls:any
  constructor(private homeService_: HomeService,private imgUrlServ:servicesUrl) {
    this.ngOnInit();
  }

  ngOnInit(): void {
    this.load = false
    this.imgUrls=this.imgUrlServ.imgUrl;
    this.homeService_.getPost('getPost','','en','','Home.MainSlider','NTROOT0','','-1').subscribe(data => {
      this.arraySlider = data,
      setTimeout(() => {
        this.load = true
      }, 200);
    })
  }

}
